export default __webpack_public_path__ + "static/media/email-blue.a58bebb8.svg";